import { Check } from 'lucide-react'
import { VersandCard } from './versand-card'
import { LiveMarktCard } from './live-markt-card'

// Zustandswahl (einzige Stelle der Prioritäts-Logik):
// live > versand > ruhe. Live gewinnt auch bei offenen Bestellungen
// (offene Bestellungen erscheinen dann weiter in der Bereich-Card).
export function HeuteBlock({ liveSession, openOrders, openOrdersCount, onOpenStore, onOpenLive, flat = false }) {
  const state = liveSession ? 'live' : (openOrdersCount > 0 ? 'versand' : 'ruhe')

  if (state === 'ruhe') return <HeuteRuhe />

  return (
    <div>
      <SectionLabel>Heute</SectionLabel>
      {state === 'live'
        ? <LiveMarktCard session={liveSession} onOpenLive={onOpenLive} />
        : <VersandCard orders={openOrders} count={openOrdersCount} onOpenStore={onOpenStore} flat={flat} />}
    </div>
  )
}

// Ruhe: bare Row (keine Card, kein "HEUTE"-Label) — channel-neutral.
function HeuteRuhe() {
  return (
    <div className="flex items-center gap-3 px-0.5 py-1 pt-[14px]">
      <div
        className="w-[38px] h-[38px] rounded-full flex items-center justify-center flex-shrink-0"
        style={{ background: 'var(--tint-stand)' }}
      >
        <Check size={20} style={{ color: 'var(--accent-stand)' }} />
      </div>
      <div>
        <div className="text-base font-medium">Alles erledigt</div>
        <div className="text-[13.5px] text-[var(--label-tertiary)] mt-px">
          Nichts zu tun — schön gemacht.
        </div>
      </div>
    </div>
  )
}

function SectionLabel({ children }) {
  return (
    <div className="mb-1.5 px-1 text-[13px] text-[var(--label-secondary)]">
      {children}
    </div>
  )
}
